/**
 * Returns the number of digits before and after the decimal point
 * @returns [number, number]
 * @example
 * beforeAndAfterDecimal(123.45) // [3, 2]
 */
export const beforeAndAfterDecimal = (value: number): [number, number] => {
  if (
    value === undefined ||
    value === null ||
    Number.isNaN(value) ||
    value === ("" as any)
  ) {
    return [0, 0];
  }

  const stringifiedNumber = Math.abs(value).toString();

  // No decimal point
  if (!stringifiedNumber.includes(".")) {
    return [stringifiedNumber.length, 0];
  }

  const [before, after] = stringifiedNumber.split(".");
  return [before?.length ?? 0, after?.length ?? 0];
};
